const pageUrl = 'http://sl.zhishen.net.cn'; //页面公共url
const apiUrl = 'http://sls.zhishen.net.cn'; //接口公共url
export default{
	pageUrl,
	apiUrl,
	//检查url中是否有code
	getQueryString(name){
		var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
		var r = window.location.search.substr(1).match(reg);
		if(r != null){
			return unescape(r[2]);
		}
		return null;
	},
	//截取code
	GetUrlParame(parameName){
		//获取url中跟在问号后面的部分
		var parames = window.location.search
		//检测参数是否存在
		if(parames.indexOf(parameName) > -1){
			var parameValue = ''
			parameValue = parames.substring(parames.indexOf(parameName), parames.length)
			//检测后面是否还有参数
			if(parameValue.indexOf('&') > -1){
				//去除后面多余的参数，得到最终的parameName=parameValue形式的值
				parameValue = parameValue.substring(0, parameValue.indexOf('&'))
				//去掉参数名，得到最终纯粹值字符串
				parameValue = parameValue.replace(parameName + '=', '')
				return parameValue
			}
			return ''
		}
	}
}


// WEBPACK FOOTER //
// ./src/common/login.js